export default __webpack_public_path__ + "static/media/txt2.affa8476.jpg";